import axios from 'utils/axios';
import { apiEndpoint } from 'config/api.config';

const questionEditorService = {
  getQuestionList: async (params = {}) => {
    try {
      const response = await axios.get(apiEndpoint('questionEditorList').url, { params });
      return response.data;
    } catch (error) {
      console.error(`Error getting question item sets`, error);
      throw error;
    }
  },
  getQuestions: async (params = {}) => {
    try {
      const response = await axios.get(apiEndpoint('questionEditorRead').url, { params });
      return response.data;
    } catch (error) {
      console.error(`Error getting questions and answers`, error);
      throw error;
    }
  }
};

export default questionEditorService;
